import React from 'react'

const ProjectMilestonesSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_700_37863)" />
    <path
      d="M40.689 27.5189C40.8243 27.6189 40.9301 27.6777 41.0124 27.76C43.2529 29.9946 45.4933 32.235 47.7278 34.4754C47.8395 34.593 47.9042 34.7577 47.9924 34.8988C47.8337 34.9341 47.6808 34.9929 47.522 34.9929C40.5126 34.9988 33.5032 34.9988 26.4938 34.9988C25.8999 34.9988 25.7588 34.8635 25.7588 34.2814C25.7588 29.7535 25.7588 25.2256 25.7588 20.6977C25.7588 20.1508 25.9058 20.0038 26.4527 20.0038C33.4797 20.0038 40.5126 20.0038 47.5396 20.0038C47.6161 20.0038 47.6984 19.9921 47.7749 20.0097C47.8513 20.0332 47.9513 20.0685 47.9866 20.1273C48.0101 20.1685 47.9572 20.2685 47.916 20.3331C47.8631 20.4096 47.7807 20.4743 47.7161 20.5448C45.4815 22.7794 43.2529 25.008 41.0183 27.2426C40.936 27.319 40.8419 27.3896 40.689 27.5189Z"
      fill="white"
    />
    <path
      d="M22.0073 34.9987C22.0073 30.4532 22.0073 25.9018 22.0073 21.3563C22.0073 20.6036 22.4778 20.0567 23.1599 20.0038C23.889 19.9509 24.483 20.4919 24.5006 21.2505C24.5182 22.0561 24.5065 22.8558 24.5065 23.6614C24.5065 31.8645 24.5065 40.0676 24.5065 48.2766C24.5065 48.4412 24.5124 48.6118 24.5006 48.7764C24.4653 49.4938 23.9126 50.0172 23.2187 49.9995C22.5424 49.9819 22.0132 49.4409 22.0073 48.7353C22.0073 46.6948 22.0073 44.6543 22.0073 42.6138C22.0073 40.0794 22.0073 37.5391 22.0073 34.9987Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_700_37863"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7000FF" />
        <stop offset="1" stopColor="#45009C" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProjectMilestonesSubcategory
